import {View} from 'MWC';
import tpl from '../templates/AdditionalProduct.jsx';
import PropTypes from 'prop-types';

export default class extends View {
    template = tpl;

    constructor(props) {
        super(props);

        this.state = {
            ui: this.uiStates.INITIAL
        };
    }

    navigate = (...args) => {
        return this.context.app.navigate(...args);
    };

    static contextTypes = {
        app: PropTypes.object,
        history: PropTypes.object
    };
}
